/**
 * AIメッセージコンポーネント
 */

import { Box } from '@chakra-ui/react';
import { MessageBubble } from '@/components/message/MessageBubble';
import { MarkdownRenderer } from '@/components/markdown/MarkdownRenderer';
import { EventNotice } from '@/components/feedback/EventNotice';
import { GeneratedImage } from '../GeneratedImage';
import { SourceLinks } from '../SourceLinks';
import { useEventMessage } from '@/hooks/useEventMessage';
import { AgeGroup, ChatEvent, GeneratedImageInfo, SourceInfo } from '@/types';

interface AIMessageProps {
  text?: string;
  isError?: boolean;
  isLoading?: boolean;
  generatedImage?: GeneratedImageInfo;
  sources?: SourceInfo[];
  event?: ChatEvent;
  ageGroup: AgeGroup;
}

export const AIMessage = ({
  text,
  isError,
  isLoading,
  generatedImage,
  sources,
  event,
  ageGroup,
}: AIMessageProps) => {
  const eventMessage = useEventMessage(event, ageGroup);

  const avatar = (
    <Box
      w="full"
      h="full"
      bg="transparent"
      backgroundImage="url('/digitane.webp')"
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
    />
  );

  const content = (
    <>
      {eventMessage ? (
        <EventNotice
          title={eventMessage.title}
          note={eventMessage.note}
          variant={eventMessage.variant}
        />
      ) : (
        text && <MarkdownRenderer content={text} />
      )}
      {sources && sources.length > 0 && <SourceLinks sources={sources} />}
    </>
  );

  const generatedImageNode = generatedImage ? (
    <GeneratedImage imageInfo={generatedImage} />
  ) : undefined;

  return (
    <MessageBubble
      role="assistant"
      content={content}
      avatar={avatar}
      isError={isError}
      isLoading={isLoading}
      generatedImage={generatedImageNode}
    />
  );
};
